<template>
  <section class="_menu-section-style">
    <form-section label="Palestrantes" v-model="isExpanded.speakers">
      <v-row v-if="!selectedSection.items || selectedSection.items.length === 0" no-gutters>
        <div class="_subtitleFormFont" style="font-weight: 600">Nenhum palestrante cadastrado.</div>
      </v-row>

      <v-row v-else no-gutters>
        <v-col cols="12">
          <Select label="Palestrantes" v-model="selectedSpeakerType" :items="speakers" :showBorder="true"/>
        </v-col>

        <v-col cols="6" class="_pt _pr-">
          <TextField v-model="selectedSection['max-speakers']" type="number" :minValueForNumber="1">
            <template slot="label">
              <div class="d-flex align-center">
                <span>Qntdade exibida</span>
                <IconTooltip>
                  Se a quantidade informada for <b class="white--text">menor</b> que o número total de participantes, um botão <b class="white--text">"Ver mais"</b> aparecerá para exibir os demais palestrantes.
                </IconTooltip>
              </div>
            </template>
          </TextField>          
        </v-col>

        <v-col cols="6" class="_pt _pl-">
          <Select 
            label="Qntidade por linha" 
            v-model="selectedSection['speakers-by-row']" 
            :items="maxSpeakersByLineOptions" 
            :showBorder="true"
          />
        </v-col>

        <v-col cols="12" class="_pt">
          <div class="_subtitleFormFont">
            Evento possui <b>{{selectedSection.items.length}} palestrantes</b>.
          </div>          
        </v-col>

        <v-col v-if="selectedSpeakerType === 'Específicos'" cols="12" class="_pt">
          <div class="_subtitleFormFont">
            <div class="d-flex align-center">
              <span>{{showSpeakersInfo}}</span>
            </div>
          </div>

          <div class="pt-4 pb-6">
            <TextField v-model="searching" placeholder="Procurar pelo nome ou empresa" icon="fa-solid fa-magnifying-glass"/>   
          </div>

          <div>
            <Checkbox 
              id="toggleAll" 
              v-model="toggleAllBtn"
              :label="toggleButtonLabel"
              @change="toggleAll"
            />            
          </div>

          <section class="select-speakers mt-3">          
            <div v-for="speaker in isSearching" :key="speaker.codigo">
              <div class="speaker-row">
                <Checkbox 
                  :id="speaker.codigo" 
                  v-model="speaker.show"
                  @change="updateCopySelectedSpeakers" 
                />
                <div class="avatar" :style="`background-image: url('${speaker.url_avatar}')`"></div>
                <div class="speaker-details">
                  <span style="font-size: 0.9rem; font-weight: 700">{{speaker.nome}}</span>
                  <span style="font-size: 0.7rem">{{speaker.cargo}} - {{speaker.empresa}}</span>
                </div>
              </div>
            </div>
          </section>
        </v-col>      

      </v-row>
    </form-section> 

    <form-section label="Grade de palestrantes" v-model="isExpanded.layout">
      <div class="layout-container mb-6">
        <div 
          v-for="(layout, index) in typesLayout" 
          :key="index"
          :class="['layout-container-cell', {'selected-cell' : selectedSection.layout.type === layout.value}]"
          @click="handleChangeLayout(layout.value)"
        >
          <v-icon v-if="selectedSection.layout.type !== layout.value" color="grey lighten-2" size="18">fa-regular fa-circle</v-icon>
          <v-icon v-else color="#0079CB" size="18">fa-solid fa-circle-check</v-icon>
          <span>{{layout.name}}</span>
        </div>
      </div>

      <div class="pb-6">
        <span class="d-block _titleFormFont">Zoom da imagem</span>
          <v-slider
            v-model="selectedSection.layout.zoom"
            :tick-labels="zoomOptions"
            :min="100"
            :max="200"
            ticks
            :step="5"
            tick-size="0"
            style="font-size: 0.85rem !important"
          />
      </div>

      <div class="pb-6">
        <span class="d-block _titleFormFont">Linkedin</span>
        <span class="d-block pt-2 pb-4" style="font-size: 12px; color: #666D80">
          Escolha entre manter o ícone da rede sempre visível ou exibi-lo apenas quando o cursor estiver sobre o item.
        </span>
        <SwitchV2 v-model="selectedSection.layout.linkedinIcon" label="Manter ícone do Linkedin sempre visível"/>
      </div>

      <div class="pb-6">
        <span class="d-block _titleFormFont">Exibir informações</span>
        <span class="d-block pt-2 pb-4" style="font-size: 12px; color: #666D80">
          Escolha se será exibido o cargo do palestrante nas informações do card.
        </span>
        <SwitchV2 v-model="selectedSection.layout.companyPosition" label="Exibir o cargo"/>
      </div>

      <div v-if="showDetailsColors.length > 0" class="pb-6">
        <span class="d-block _titleFormFont">Cores detalhes</span>
        <v-row no-gutters>
          <v-col v-if="showDetailsColors.includes('color1')" cols="6" class="_pt _pr-">
            <ColorPickerV2 :colorSelected="selectedSection.layout" type="color1" title=""/>   
          </v-col>
          <v-col v-if="showDetailsColors.includes('color2')" cols="6" class="_pt _pl-">
            <ColorPickerV2 :colorSelected="selectedSection.layout" type="color2" title=""/>   
          </v-col>
        </v-row>
      </div>

      <div class="pb-6">
        <span class="d-block _titleFormFont">Cores texto</span>
        <v-row no-gutters>
          <v-col cols="6" class="_pt _pr-">
            <ColorPickerV2 :colorSelected="selectedSection.layout" type="text-color1" title="Nome"/>   
          </v-col>
          <v-col cols="6" class="_pt _pl-">
            <ColorPickerV2 :colorSelected="selectedSection.layout" type="text-color2" title="Cargo/Empresa"/>   
          </v-col>
        </v-row>
      </div>

      <div class="pb-6">
        <span class="d-block _titleFormFont">Cores pop-up</span>
        <span class="d-block pt-2 pb-4" style="font-size: 12px; color: #666D80">
          Caso alguma informação sobre o palestrante for muito extensa ela será exibida na íntegra em um pop-up ao passar o mouse.
        </span>        
        <v-row no-gutters>
          <v-col cols="6" class="_pt _pr-">
            <ColorPickerV2 :colorSelected="selectedSection.layout" type="tooltip-text-color" title="Texto"/>   
          </v-col>
          <v-col cols="6" class="_pt _pl-">
            <ColorPickerV2 :colorSelected="selectedSection.layout" type="tooltip-color" title="Fundo"/>   
          </v-col>
        </v-row>
      </div>
    </form-section>      

    <form-section label="Título" v-model="isExpanded.title">
      <Texts 
        useTextArea
        textType="title" 
        :sectionType="selectedSection.type" 
        :selectedSection="selectedSection" 
        :hide="['alignment']"        
      />
    </form-section>

    <form-section label="Subtítulo" v-model="isExpanded.subtitle">
      <Texts 
        useTextArea
        textType="subtitle" 
        :sectionType="selectedSection.type" 
        :selectedSection="selectedSection" 
        :hide="['alignment']"
      />
    </form-section>

    <form-section label="Botão" v-model="isExpanded.button">
      <Buttons 
        :sectionsId="sectionsId" 
        :sectionType="selectedSection.type" 
        :selectedSection="selectedSection.buttons[0]"
        :hasBindedStyle="hasBindedStyle" 
        :hide="['alignment']"
      />
    </form-section>

    <form-section label="Fundo" v-model="isExpanded.bg" :divider="false">
      <Background 
        :selectedSection="selectedSection" 
        :sectionType="selectedSection.type"
        :availableTypes="['color', 'image']"
        @update="onUpdateBackground"
      />
    </form-section>        
  </section>
</template>

<script>
import FormSection from '../../_v2/utils/FormSection.vue'
import Texts from '../forms/formsV2/Texts.vue'
import Buttons from '../forms/formsV2/Buttons.vue'
import Background from '../forms/formsV2/Background.vue'
import TextField from '../../_v2/ui/TextField.vue'
import Select from '../../_v2/ui/Select.vue'
import ButtonV2 from '../../_v2/ui/Button.vue'
import Checkbox from '../../_v2/ui/Checkbox/Checkbox.vue'
import ColorPickerV2 from '../../_v2/ui/ColorPickerV2.vue'
import IconTooltip from '../../_v2/ui/IconTooltip.vue'
import SwitchV2 from '../../_v2/ui/Switch.vue'

export default {
  name: 'SpeakersSection',
  components: { 
    FormSection, 
    Texts, 
    Buttons, 
    Background, 
    TextField, 
    Select, 
    Checkbox, 
    ColorPickerV2, 
    ButtonV2,
    IconTooltip,
    SwitchV2
  },
  props: {
    selectedSection: {type: Object, required: true},
    sectionsId: {type: Array, required: true}
  },
  computed: {
    hasBindedStyle () {
      return this.selectedSection.idLayout ? true : false
    },

    areAllSpeakersSelected () {
      return this.selectedSection.items.every(speaker => speaker.show)
    },

    selectedSpeakers () {
      return this.selectedSection.items.filter(speaker => speaker.show)
    },

    toggleButtonLabel () {
      if (this.selectedSpeakers.length === 0 || this.selectedSpeakers.length !== this.selectedSection.items.length) return 'Selecionar todos'
      if (this.selectedSpeakers.length === this.selectedSection.items.length) return 'Desselecionar todos'
    },

    showSpeakersInfo () {
      if (this.selectedSpeakers.length > 0) {
        if (this.selectedSpeakers.length === this.selectedSection.items.length) return 'Todos selecionados'
        else return `${this.selectedSpeakers.length} selecionados`
      }
      else return 'Nenhum selecionado'
    },

    isSearching () {
      if (this.searching) return this.resultOfSearch
      else return this.selectedSection.items
    },

    showDetailsColors () {
      const selectedLayout = this.selectedSection.layout.type
      const colors = this.typesLayout.find(layout => layout.value === selectedLayout)
      return colors ? colors.colors : []
    },

    maxSpeakersByLineOptions () {
      const selectedLayout = this.selectedSection.layout.type
      const maxByLine = this.typesLayout.find(layout => layout.value === selectedLayout)
      return maxByLine ? maxByLine.maxByLine : []
    }
  },

  data: () => ({
    isExpanded: {title: false, subtitle: false, button: false, bg: false, layout: true, speakers: true},      
    speakers: ['Todos', 'Específicos'],
    selectedSpeakerType: '',
    copySelectedSpeakers: [],
    searching: '',
    resultOfSearch: [],
    toggleAllBtn: false,
    typesLayout: [
      { name: "Layout 01", value: "layout1", colors: ['color1'], maxByLine: [3, 4, 5] },
      { name: "Layout 02", value: "layout2", colors: [], maxByLine: [3, 4, 5, 6, 7] },
      { name: "Layout 03", value: "layout3", colors: [], maxByLine: [3, 4, 5] },
      { name: "Layout 04", value: "layout4", colors: ['color1'], maxByLine: [3, 4, 5] },
      { name: "Layout 05", value: "layout5", colors: ['color1'], maxByLine: [3, 4, 5] },
      { name: "Layout 06", value: "layout6", colors: [], maxByLine: [3, 4] },
      { name: "Layout 07", value: "layout7", colors: ['color1', 'color2'], maxByLine: [3, 4, 5] },
      { name: "Layout 08", value: "layout8", colors: ['color1', 'color2'], maxByLine: [3, 4, 5] },
      { name: "Layout 09", value: "layout9", colors: ['color1', 'color2'], maxByLine: [3, 4, 5] },
      { name: "Layout 10", value: "layout10", colors: ['color1', 'color2'], maxByLine: [3, 4, 5] }
    ],
    zoomOptions: ['1x', '', '', '', '', '1.25x', '', '', '', '', '1.50x', '', '', '', '', '1.75x', '', '', '', '', '2x'],
    speakersByRow: [ 3, 4, 5, 6, 7]
  }),

  mounted () {
    this.copySelectedSpeakers = JSON.parse(JSON.stringify(this.selectedSpeakers))
    
    if (this.selectedSection.typeShow) {
      this.selectedSpeakerType = this.selectedSection.typeShow
    }
    else this.selectedSpeakerType = this.areAllSpeakersSelected ? 'Todos' : 'Específicos'

    this.toggleAllBtn = this.areAllSpeakersSelected
  },

  methods: {
    onUpdateBackground ($event) {
      this.selectedSection.bg['background-type'] = $event['background-type']
      this.selectedSection.bg['background-image'] = $event['background-image']
    },

    showOptions (field) {
      if (this.selectedSection.overlappingName) {
        return ['border'].includes(field)
      } else {
        return true
      }
    },

    toggleAll () {
      if (this.selectedSpeakers.length !== this.selectedSection.items.length) {
        this.selectedSection.items.forEach(speaker => speaker.show = true)
      } else {
        this.selectedSection.items.forEach(speaker => speaker.show = false)
      }
      this.selectedSection.typeShow = 'Específicos'
      this.searching = ''
    },

    updateCopySelectedSpeakers () {
      this.selectedSection.typeShow = 'Específicos'
      this.copySelectedSpeakers = JSON.parse(JSON.stringify(this.selectedSpeakers))
    },

    handleChangeLayout (layoutType) {
      this.selectedSection.layout.type = layoutType

      // update speakers-by-row when change type of layout
      const layoutOpt = this.typesLayout.find(layout => layout.value === layoutType)
      if (layoutOpt) {
        const maxValueByRow = Math.max(...layoutOpt.maxByLine)
        if (this.selectedSection['speakers-by-row'] > maxValueByRow)
          this.selectedSection['speakers-by-row'] = maxValueByRow
      }
    },    
  },

  watch: {
    selectedSpeakerType (type) {
      this.selectedSection.typeShow = type
      if (type === 'Todos') {
        this.selectedSection.items.forEach((speaker) => {
          speaker.show = true
        })
      } else {
        this.selectedSection.items.forEach(speaker => {
          for (let speakerCopy of this.copySelectedSpeakers) {
            if (speaker.codigo === speakerCopy.codigo) {
              speaker.show = JSON.parse(JSON.stringify(speakerCopy.show))
              break
            } else speaker.show = false
          }          
        })
      }
    },

    areAllSpeakersSelected (v) {
      this.toggleAllBtn = v
    },

    searching (value) {
      if (value) {
        const search = value.toLowerCase()
        this.resultOfSearch = this.selectedSection.items.filter(speaker => {
          const searchByName = speaker.nome.toLowerCase().includes(search)
          const searchByCompany = speaker.empresa.toLowerCase().includes(search)
          return searchByName || searchByCompany
        })
      }
    }
  }    
}
</script>

<style scoped>
.select-speakers {
  max-height: 250px;
  width: 100%;
  overflow: hidden;
  overflow-y: auto; 
}

.select-speakers .speaker-row {
  display: flex;
  align-items: center;
  max-height: 90px;
  gap: 16px;
  margin: 16px 6px 8px 6px;
  border-bottom: 1px solid #EDEDF1;
  padding: 0 8px 12px 8px;
}

.speaker-row .avatar {
  width: 30px;
  height: 30px;
  border-radius: 4px;
  background-repeat: no-repeat;
  background-size: cover;
}

.speaker-row .speaker-details {
  display: flex;
  flex: 1;
  flex-direction: column;
}

.select-speakers > div:first-of-type .speaker-row {
  margin-top: 0px;
}

.select-speakers > div:last-of-type .speaker-row {
  border: 0
}

.layout-container {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  max-height: 125px;
  overflow-y: auto;
  overflow-x: hidden;
  gap: 12px;
}

.layout-container-cell {
  display: flex;
  gap: 12px;
  height: 40px;
  width: 134px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  border-radius: 8px;
  border: #EDEDF1 1px solid;
  background-color: #F6F7F7;
  cursor: pointer;
  transform: all 0.5s;
}

.layout-container::-webkit-scrollbar {
  width: 8px;
}

.layout-container::-webkit-scrollbar-thumb {
  background-color: rgba(245, 247, 249, 1);
  border-radius: 5px;
}

.layout-container::-webkit-scrollbar-track {
  background-color: white;
}
</style>